// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---docz-functions-mdx": () => import("./../../docz/functions.mdx" /* webpackChunkName: "component---docz-functions-mdx" */),
  "component---docz-index-mdx": () => import("./../../docz/index.mdx" /* webpackChunkName: "component---docz-index-mdx" */),
  "component---docz-installation-mdx": () => import("./../../docz/installation.mdx" /* webpackChunkName: "component---docz-installation-mdx" */),
  "component---docz-hoc-basic-usage-mdx": () => import("./../../docz/hoc/basic-usage.mdx" /* webpackChunkName: "component---docz-hoc-basic-usage-mdx" */),
  "component---docz-hoc-dynamic-approach-mdx": () => import("./../../docz/hoc/dynamic-approach.mdx" /* webpackChunkName: "component---docz-hoc-dynamic-approach-mdx" */),
  "component---docz-hoc-fallback-mdx": () => import("./../../docz/hoc/fallback.mdx" /* webpackChunkName: "component---docz-hoc-fallback-mdx" */),
  "component---docz-hoc-tetst-mdx": () => import("./../../docz/hoc/tetst.mdx" /* webpackChunkName: "component---docz-hoc-tetst-mdx" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

